import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { IOrganizationViewModel } from 'src/app/ViewModel/OrganizationModel';
import { groupBy } from 'lodash';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { RoleMemberPostModel } from 'src/app/ViewModel/RoleMemberPostModel';
import { MemberRoleLinkService } from 'src/app/Service/member-role-link/member-role-link.service';
import { ReplectRoleMemberModel, RoleMemberMappedModel } from 'src/app/ViewModel/RoleMemberMappedModel';
import { ReplaceMemberComponent } from '../replace-member/replace-member.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-project-member-link',
	templateUrl: './project-member-link.component.html',
	styleUrls: ['./project-member-link.component.css']
})
export class ProjectMemberLinkComponent implements OnInit {

	businessGroupId!: string | number | null;
	projectBusinessGroupId!: number | null;
	/** Business group list */
	businessGroupList: IOrganizationViewModel[] = [];
	/** Project business group listF */
	projectBusinessGroupList: BusinessGroupModel[] = [];
	memberList: any | ProjectMemberModel[] = [];
	projectSelectedMembers: ProjectMemberModel[] = [];
	/** Cart filtered data source. removed duplication with selected data */
	cartDataSource: ProjectMemberModel[] = [];
	/** Cart Right side (seleceted data) */
	cartSelectedList: any = [];
	cartRequest = {};
	cartSelectedListCopy!: any[];
	userId!: number;
	ReplectRoleMemberModel: ReplectRoleMemberModel[];

	constructor(
		public projectMemberLinkService: ProjectMemberLinkService,
		public organizationService: OrganizationService,
		public memberService: ExternalMemberService,
		public commonService: CommonService,
		public notificationService: NotificationService,
		private memberRoleLinkService: MemberRoleLinkService,
		private dialog: MatDialog
	) { }

	ngOnInit() {
		this.userId = this.commonService.getLoggedInUserId();
		this.getBusinessGroup();
		this.getProjectBusinessGroup();
	}

	/**
	 * Change key format. Remove already selected members.
	 * @param inputArr 
	 * @param alreadySelectedMembers 
	 */
	changeKeyFormat(inputArr: any[], alreadySelectedMembers: []) {
		let grpdSelectedMembers = groupBy(alreadySelectedMembers, 'memberId');
		let outputArr: {}[] = [];
		inputArr.forEach(eachObj => {
			let output: any = {};
			if (eachObj['is_Active']) {
				output['companyCode'] = eachObj['company_Code'];
				output['designation'] = eachObj['designation'];
				output['eMailId'] = eachObj['eMail_Id'];
				output['eccWebLogin'] = eachObj['ecc_Web_Login'];
				output['isActive'] = eachObj['is_Active'];
				output['isInternal'] = eachObj['is_Internal'];
				output['memberId'] = eachObj['member_Id'];
				output['memberName'] = eachObj['member_Name'];
				output['memberShortName'] = eachObj['member_Short_Name'];
				output['mobileNo'] = eachObj['mobile_No'];
				output['reportingTo'] = eachObj['reporting_To'];
				output['result'] = eachObj['result'];
				output['staffPSNo'] = eachObj['staff_PSNo'];
				output['successCode'] = eachObj['successCode'];
				output['successMessage'] = eachObj['successMessage'];
				output['userId'] = eachObj['user_Id'];

				if (!(grpdSelectedMembers && grpdSelectedMembers[output['memberId']] && grpdSelectedMembers[output['memberId']].length)) {
					outputArr.push(output);
				}
			}
		});
		return outputArr;
	}


	async getBusinessGroup() {
		let organizationList: any = await this.organizationService.getOrganizationList().toPromise();
		this.businessGroupList = organizationList.filter((eachOrg: { is_Active: any; }) => eachOrg.is_Active);
	}

	async getProjectBusinessGroup() {
		let response: any = await this.projectMemberLinkService.getProjectBusinessGroup(this.commonService.getProjectId()).toPromise();
		this.projectBusinessGroupList = response.filter((each: { is_Active: any; }) => each.is_Active);
	}


	async getMemberList() {
		let selectedCount = 0;
		this.projectSelectedMembers = await this.projectMemberLinkService.getSelectedMemberList(this.commonService.getProjectId(), this.projectBusinessGroupId).toPromise();
		this.setCartValues(selectedCount);
	}


	/**
	 * Compare two arrays and remove data which presents in second array
	 * @param dataSource Main data array
	 * @param selectedArray selected array. Needs to remove from main data array
	 * @param key value key name
	 */
	removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
		let filteredArray: any[] = [],
			grpdSelecetedArray = groupBy(selectedArray, key);

		dataSource.forEach((eachData: any) => {
			if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
				filteredArray.push(eachData);
			}
		});
		return filteredArray;
	}

	setCartValues(selectedCount?: number) {
		if (selectedCount == 0) {
			this.cartDataSource = this.removeDuplicates(this.memberList, this.projectSelectedMembers, 'memberId');
			this.cartSelectedList = [];
			this.cartSelectedListCopy = [];
			this.projectSelectedMembers.forEach(eachMember => {
				let cartValue: any = this.getAsCartSelectedValue(eachMember.memberId, eachMember.memberName);
				this.cartSelectedList.push(cartValue);
				this.cartSelectedListCopy.push(cartValue);
			});
		} else {
			this.cartDataSource = this.removeDuplicates(this.memberList, this.projectSelectedMembers, 'memberId');
			this.projectSelectedMembers.forEach(eachMember => {
				let cartValue = this.getAsCartSelectedValue(eachMember.memberId, eachMember.memberName);
				this.cartSelectedList.push(cartValue);
				this.cartSelectedListCopy.push(cartValue);
			});
		}
		this.setCartParams();
	}

	/**
	 * Change data to respective cart selected data format
	 * @param value 
	 * @param text 
	 */
	getAsCartSelectedValue(value: string | number, text: string) {
		value = value.toString().trim();
		text = text.trim();
		let output = {
			value,
			text: value + ' - ' + text
		};
		return output;
	}


	save(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {

		if (!this.businessGroupId) {
			this.notificationService.showToast('Select Business Group', 'Warning');
			return;
		}

		if (!this.projectBusinessGroupId) {
			this.notificationService.showToast('Select Project Business Group', 'Warning');
			return;
		}

		//let activeIds = this.activeIds(event),
		let activeIds = this.activeIds(this.cartSelectedList),
			inactiveIds = this.getInactiveIds(this.cartSelectedListCopy, activeIds),
			reqData = {
				"projectId": this.commonService.getProjectId(),
				"groupId": this.projectBusinessGroupId,
				"reportingTo": 0,
				"activeMemberIds": activeIds.length ? activeIds.toString() : null,
				"inactiveMemberIds": inactiveIds.length ? inactiveIds.toString() : null,
				"createdBy": this.userId,
				"roleMembersMapping": []
			};

		if (inactiveIds.length > 0) {
			let inActiveMemberData: RoleMemberPostModel = {
				"roleMembersMapping": [],
				"groupId": this.projectBusinessGroupId,
				"projectId": this.commonService.getProjectId(),
				"createdBy": this.commonService.getLoggedInUserId(),
				"inActiveMemberIds": inactiveIds.length ? inactiveIds.toString() : null,
			}

			this.memberRoleLinkService.CheckRoleMemberWFAssignment(inActiveMemberData).subscribe(data => {
				if (data.length > 0) {
					this.ReplectRoleMemberModel = data;

					let refData: RoleMemberMappedModel[] = this.ReplectRoleMemberModel.map(y => {
						return {
							memberId: y.member_Id,
							isCheck: false,
							roleId: y.role_Id,
							assignmentDetails: '',
							delegateMemberId: y.replaceMemberId
						}
					})

					const dialogRef = this.dialog.open(ReplaceMemberComponent, {
						panelClass: ['mat-dialog-secondary', 'w80'],
						data: { RoleMembersUpdated: refData, ReplacementRequiredMembers: this.ReplectRoleMemberModel, IsMemberRemoved: true }
					});
					dialogRef.afterClosed().subscribe((res: any) => {
						if (res.length > 0) {
							let UpdatedReqData = {
								"projectId": this.commonService.getProjectId(),
								"groupId": this.projectBusinessGroupId,
								"reportingTo": 0,
								"activeMemberIds": activeIds.length ? activeIds.toString() : null,
								"inactiveMemberIds": inactiveIds.length ? inactiveIds.toString() : null,
								"createdBy": this.userId,
								"roleMembersMapping": res,
							};

							this.projectMemberLinkService.postProjectMemberLink(UpdatedReqData).subscribe(data => {
								this.notificationService.handleResponse(data);
							});
						}
					});
				}
				else {
					this.projectMemberLinkService.postProjectMemberLink(reqData).subscribe(data => {
						this.notificationService.handleResponse(data);
					});
				}
			})
		}
		else {
			this.projectMemberLinkService.postProjectMemberLink(reqData).subscribe(data => {
				this.notificationService.handleResponse(data);
			});
		}
	}

	/**
	 * Compare previous selected cart data input and current selected cart data input to get inactive ids
	 * @param prevSelected 
	 * @param currentSelected 
	 * @returns Ex: ['16345']
	 */
	getInactiveIds(prevSelected: any[], currentSelected: string | any[]) {
		let inActiveIds: any[] = [];
		prevSelected.forEach(eachSelected => {
			if (!currentSelected.includes(eachSelected['value'])) {
				inActiveIds.push(eachSelected['value']);
			}
		});
		return inActiveIds;
	}

	/**
	 * Setting cart data
	 */
	setCartParams() {
		this.cartRequest = {
			'params': {
				'LockingType': 'P',
				'selectedCartItems': this.cartSelectedList,
			},
			'settings': {
				'mode': 'popup',
				'textField': 'memberName',
				'valueField': 'memberId',
				'cartLabel': 'Members',
				'minimumSelectedItemCount': 0
			},
			'dataSource': this.cartDataSource,
		}
	}

	async changeBusinessGroup(event: { value: string | number; }) {
		let selectedCount: number = 0;
		if (event.value != '-2') {
			selectedCount = selectedCount + 1;
			this.businessGroupId = event.value;
			if (this.businessGroupId) {
				let x: any = this.businessGroupId
				let members: any = await this.memberService.GetMembersList({ group_Id: parseInt(x) }).toPromise();
				let alreadySelectedMembers = await this.projectMemberLinkService.getSelectedMemberList(this.commonService.getProjectId(), null).toPromise();
				this.memberList = this.changeKeyFormat(members, alreadySelectedMembers);
			}
			this.projectSelectedMembers = [];
			this.setCartValues(selectedCount);
		} else {
			this.businessGroupId = null;
			this.memberList = [];
			this.projectSelectedMembers = [];
		}
	}

	changeProjectBusinessGroup(event: { value: string; }) {
		let selectedCount = 0;
		if (event.value != '-2') {
			this.projectBusinessGroupId = parseInt(event.value);
			this.getMemberList();
		} else {
			this.projectBusinessGroupId = null;
			this.projectSelectedMembers = [];
			this.setCartValues(selectedCount);
		}
	}

	getSelectedCartItems(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {
		this.save(event);
	}

	/**
   * Get cart selected value as array of ids
   * @param event
   * @returns Ex: [162065,162064] 
   */
	activeIds(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {
		let selectedIds: (string | number)[] = [];
		event.forEach(eachMember => {
			selectedIds.push(eachMember.value);
		});
		return selectedIds;
	}

}
